import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  AfterViewInit,
} from "@angular/core"
import { ToasterLibraryService } from "@service/index"
declare var $: any

// Interface for suggestion items (matching the structure you want to filter/display)
interface Suggestion {
  key: string
  // Add other properties if needed for display in the list
}

// Keep your interfaces for templateLegends structure if they are defined here
interface TemplateLegendItem {
  template?: string
  legend?: { template: string; name: string }
  name?: string
  // id?: number
  // description?: string
  // prompt?: string
  // preview?: string
}

interface TemplateLegendCategory {
  [key: string]: TemplateLegendItem[]
}

interface TemplateLegendInsert {
  status?: boolean
  default_legend?: string
  ai_legend_template?: {
    preview?: string
  }
}

@Component({
  selector: "app-editor",
  templateUrl: "./editor.component.html",
  styleUrls: ["./editor.component.scss"],
})
export class EditorComponent implements OnInit, AfterViewInit {
  public showCC = false
  public showBCC = false
  contents: string
  previewButtonState: boolean = false
  editorContentBeforePreview = ""

  @Output() templateChanged: EventEmitter<any> = new EventEmitter()
  @Input() htmlTemplate: string
  @Input() clearNote: boolean = false
  @Input("editorID") editorID = "summernote"
  @Input() templateLegends: TemplateLegendCategory = {}
  @Input() set selectedTemplateLegendInsert(value: TemplateLegendInsert) {
    // console.log("Input received in editor:", value)
    if (value?.status === true) {
      this._selectedTemplateLegendInsert = value
      if (value.default_legend) {
        const id = "#" + this.editorID
        const summernoteData = $(id).data("summernote")
        if (summernoteData) {
          $(id).summernote("pasteHTML", value.default_legend)
        }
      } else if (value?.ai_legend_template?.preview) {
        this.handleTemplateLegendInsert(value)
      }
    }
  }
  get selectedTemplateLegendInsert(): TemplateLegendInsert {
    return this._selectedTemplateLegendInsert
  }
  private _selectedTemplateLegendInsert: TemplateLegendInsert = {}

  constructor(private toasterLibrary: ToasterLibraryService) {}

  ngOnInit() {
    // console.log(
    //   "selectedTemplateLegendInsert: " +
    //   JSON.stringify(this.selectedTemplateLegendInsert)
    // )

    // Summernote is currently not ported as a native angular2 module
    // For a quick use it we use the component a wrapper
    // Plugin events can be used to keep component props
    // in sync with the editor content
    //  $('#summernote').summernote('pasteHTML', this.htmlTemplate);
    //$('#summernote').summernote('editor.insertText', this.emailTemplate);
  }
  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    let self = this
    let id = "#" + this.editorID

    let note = $(id).summernote({
      toolbar: [
        // [groupName, [list of button]]
        ["style", ["bold", "italic", "underline", "clear"]],
        ["font", ["strikethrough", "superscript", "subscript"]],
        ["fontsize", ["fontsize"]],
        ["fontname", ["fontname"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["height", ["height"]],
        ["copyButton", ["copyButton"]],
        // ["previewButton", ["previewButton"]],
        // ["aiButton", ["generateAIContent"]], // TODO: I think this is not necessary after changing the PLAN
      ],
      buttons: {
        copyButton: function (context) {
          var ui = $.summernote.ui
          // create button
          var button = ui.button({
            contents: '<i class="fa fa-copy"/>',
            tooltip: "Copy",
            click: function () {
              self.copyMessage(context.code())
            },
          })
          return button.render()
        },
        previewButton: function (context) {
          var ui = $.summernote.ui
          var button = ui.button({
            contents: '<i class="fa fa-eye"/>',
            tooltip: "Preview",
            className: "btn-preview",
            click: function () {
              self.previewClickHandler(context, self, ui)
            },
          })
          return button.render() // return button as jquery object
        },
        //   generateAIContent: function (context) {
        //     var ui = $.summernote.ui
        //     var button = ui.button({
        //       contents: '<i class="fa fa-magic"/> Generate AI Content',
        //       tooltip: "Generate email content using AI",
        //       click: function () {
        //         self.generateAIContent(function (content) {
        //           context.invoke("editor.insertText", content) // Inserta el contenido generado
        //           self.templateChanged.emit($(id).summernote("code")) // Emite el cambio
        //         })
        //       },
        //     })
        //     return button.render()
        //   },
      },
      height: 400,
      dialogsInBody: true,
      callbacks: {
        onChange: (contents, $editable) => {
          this.contents = contents
          this.saveDraft(contents)
          const id = `#${this.editorID}`
          $(id).summernote("saveRange")
          this.templateChanged.emit(this.contents)
        },
      },
      onKeyup: () => {
        const id = `#${this.editorID}`
        $(id).summernote("saveRange")
      },
      onMouseup: () => {
        const id = `#${this.editorID}`
        $(id).summernote("saveRange")
      },
      hint: {
        match: /\{([^}\s]*)$/,

        search: function (keyword, callback) {
          const allLegends = []

          for (const category in self.templateLegends) {
            // if (category == "ai_variables") {
            //   continue
            // }
            const legends = self.templateLegends[category]

            if (Array.isArray(legends)) {
              legends.forEach(legendItem => {
                let templateKey = ""
                let templateName = ""

                if (legendItem.template) {
                  templateKey = legendItem.template
                  templateName = legendItem.name
                } else if (legendItem.legend && legendItem.legend.template) {
                  templateKey = legendItem.legend.template
                  templateName = legendItem.legend.name
                } else if (legendItem.name) {
                  templateKey = `{${legendItem.name.replace(/ +/g, "_")}}`
                }

                if (
                  typeof templateName === "string" &&
                  typeof templateKey === "string" &&
                  (templateKey.toLowerCase().includes(keyword.toLowerCase()) ||
                    templateName
                      .toLowerCase()
                      .trim()
                      .includes(keyword.toLowerCase().trim()))
                ) {
                  allLegends.push({ key: templateKey, name: templateName })
                }
              })
            }
          }

          allLegends.sort((a, b) => a.key.localeCompare(b.key))

          callback(allLegends)
        },
        content: function (item) {
          return item.key
        },
        template: function (item) {
          return item.name
        },
        delay: 100,
      },
    })

    const draft = localStorage.getItem(`${this.editorID}_draft`)
    // console.log("Draft: ", JSON.stringify(draft));
    // console.log("selectedTemplateLegendInsert: ", this.selectedTemplateLegendInsert);

    if (draft) {
      $(id).summernote("code", draft)
    } else {
      $(id).summernote("code", this.htmlTemplate)
    }

    if (this.selectedTemplateLegendInsert?.status) {
      this.handleTemplateLegendInsert(this.selectedTemplateLegendInsert)
    }

    $(id).summernote({
      disableDragAndDrop: true,
    })
  }

  private handleTemplateLegendInsert(value: TemplateLegendInsert) {
    const id = "#" + this.editorID
    const summernoteData = $(id).data("summernote")

    if (summernoteData) {
      try {
        $(id).summernote('restoreRange');
      } catch {
        $(id).summernote('focus');
      }

      const currentEditorContent = $(id).summernote("code")
      if (value?.ai_legend_template?.preview) {
        const previewContent = value.ai_legend_template.preview.trim()
        if (!currentEditorContent.includes(previewContent)) {
          const contentToInsert =
            currentEditorContent === "" || currentEditorContent === "<p></p>"
              ? previewContent
              : previewContent + "<br>"
          $(id).summernote("pasteHTML", contentToInsert)
        } else {
          this.toasterLibrary.error(
            null,
            "Content already exists in the editor, skipping insertion."
          )
        }
      } else if (value?.default_legend) {
        const defaultLegend = value.default_legend.trim()
        $(id).summernote("pasteHTML", defaultLegend)
      }
    }
  }

  // This function is called when the "Generate AI Content" button is clicked
  // generateAIContent(callback: (content: string) => void): void {
  //   return callback("AI Content generated here")
  // }

  ngOnChanges(changes) {
    const id = "#" + this.editorID

    if (changes && changes.clearNote && changes.clearNote.currentValue) {
      // console.log("ID: " + id)
      $(id).summernote("code", "")
    }

    if (
      changes &&
      changes.htmlTemplate &&
      changes.htmlTemplate.currentValue !== undefined
    ) {
      // console.log("ID: " + id)
      const summernoteData = $(id).data("summernote")
      if (summernoteData || summernoteData !== "") {
        $(id).summernote("code", this.htmlTemplate)
      } else {
        this.toasterLibrary.warning(
          null,
          "Summernote not initialized when htmlTemplate changed."
        )
      }
    }

    // if (changes && changes.selectedTemplateLegendInsert) {
    //   const currentValue = changes.selectedTemplateLegendInsert.currentValue
    //   console.log("ID: " + id)

    //   console.log(
    //     "currentValue:",
    //     JSON.stringify(currentValue) + " typeof: " + typeof currentValue
    //   )

    //   if (
    //     currentValue &&
    //     typeof currentValue !== null &&
    //     currentValue?.status
    //   ) {
    //     const summernoteData = $(id).data("summernote")

    //     if (summernoteData) {
    //       const currentEditorContent = $(id).summernote("code")
    //       if (
    //         !currentEditorContent.includes(
    //           currentValue?.ai_legend_template?.preview
    //         )
    //       ) {
    //         const contentToInsert =
    //           currentEditorContent === "" ||
    //           currentEditorContent === "<p><br></p>"
    //             ? currentValue?.ai_legend_template?.preview ||
    //               currentValue?.default_legend
    //             : "<br>" + currentValue?.ai_legend_template?.preview ||
    //               currentValue?.default_legend

    //         $(id).summernote("pasteHTML", contentToInsert)

    //         console.log(
    //           "Insertion attempted using $(id).summernote('pasteHTML')."
    //         )
    //       } else if (
    //         currentEditorContent.includes(
    //           currentValue?.ai_legend_template?.preview
    //         )
    //       ) {
    //         this.toasterLibrary.error(
    //           null,
    //           "Content already exists in the editor, skipping insertion."
    //         )
    //       }
    //     } else {
    //       this.toasterLibrary.warning(
    //         null,
    //         "Summernote not initialized when selectedTemplateLegendInsert changed."
    //       )
    //     }
    //   }
    // }
  }

  private saveDraft(html: string) {
    if (html != "") { 
      const prefix = this.editorID.split('_')[0];
      
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key && key.startsWith(prefix + '_')) {
          localStorage.removeItem(key);
        }
      }
      
      localStorage.setItem(`${this.editorID}_draft`, html);
    }
  }

  public copyMessage(val: string) {
    const selBox = document.createElement("textarea")
    selBox.style.position = "fixed"
    selBox.style.left = "0"
    selBox.style.top = "0"
    selBox.style.opacity = "0"
    selBox.value = val
    document.body.appendChild(selBox)
    selBox.focus()
    selBox.select()
    document.execCommand("copy")
    document.body.removeChild(selBox)
    this.toasterLibrary.success("Copy", "Copied to Clipboard!")
  }
  disableEditor() {
    let id = "#" + this.editorID
    $(id).summernote("disable")
  }
  enableEditor() {
    let id = "#" + this.editorID
    $(id).summernote("enable")
  }
  previewClickHandler(context, self, ui) {
    self.previewButtonState = !self.previewButtonState
    var $editor = context.layoutInfo.editor
    var $toolbar = context.layoutInfo.toolbar
    var $codable = context.layoutInfo.codable
    var $editable = context.layoutInfo.editable

    // console.log('sommernote preview btn state:',$editor.hasClass('previewButton'));
    var $btn = $toolbar.find("button")
    var $previewBtn = $toolbar.find(".btn-preview")
    $btn = $btn.not(".btn-preview")
    ui.toggleBtn($btn, !self.previewButtonState)
    ui.toggleBtnActive($previewBtn, self.previewButtonState)
    if (self.previewButtonState) {
      self.editorContentBeforePreview = context.code()
      let str: string = $editable[0]
        ? $editable[0]["innerHTML"]
          ? $editable[0]["innerHTML"]
          : ""
        : ""
      str = str.replace(/&lt;/gm, "<")
      str = str.replace(/&gt;/gm, ">")
      if (str) {
        context.code(str)
      }
    } else {
      context.code(self.editorContentBeforePreview)
    }
  }
}
